import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import { datadogLogs } from '@datadog/browser-logs';
import { env } from './features/env';
import type { ErrorReportingUser } from './features/error-reporting/errorReportingUser';

const RUNNING_LOCALLY = window.location.hostname === 'localhost';
const DATADOG_ENABLED_FROM_ENV = process.env.REACT_APP_ENABLE_DATADOG === 'true';

if (DATADOG_ENABLED_FROM_ENV && !RUNNING_LOCALLY) {
	datadogRum.init({
		service: 'ledidi-frontend',
		applicationId: '18d7bf1c-7c2e-48ba-b00c-47ebcb08a251',
		clientToken: 'puba2f4e8e8c0966633b457b39e7be67680',
		site: 'datadoghq.eu',
		env: process.env.REACT_APP_DATADOG_ENVIRONMENT,
		version: process.env.REACT_APP_VERSION,
		sessionSampleRate: 100,
		sessionReplaySampleRate: 100,
		traceSampleRate: 100,
		trackResources: true,
		trackLongTasks: true,
		trackUserInteractions: true,
		defaultPrivacyLevel: 'mask',
		// Action names are derived from the clicked element's label/aria-label/text,
		// which defaultPrivacyLevel does NOT cover — that only masks the session
		// replay DOM. Without this, clicking an answer option in a dataset entry
		// sends the option's visible text (a diagnosis, a medication) to RUM as the
		// action name. Same reasoning as apps/patient-frontend.
		enablePrivacyForActionName: true,
		plugins: [reactPlugin()],
		allowedTracingUrls: [
			env.REACT_APP_API_URL_PROJECT,
			env.REACT_APP_API_URL_STATS,
			env.REACT_APP_API_URL_REPORT,
			env.REACT_APP_API_URL_USER,
			env.REACT_APP_API_URL_USER_ACCOUNT,
			env.REACT_APP_API_URL_NOTIFICATIONS,
			env.REACT_APP_API_URL_DATAENTRY
		]
	});

	datadogLogs.init({
		service: 'ledidi-frontend',
		clientToken: 'puba2f4e8e8c0966633b457b39e7be67680',
		site: 'datadoghq.eu',
		env: process.env.REACT_APP_DATADOG_ENVIRONMENT,
		version: process.env.REACT_APP_VERSION,
		forwardErrorsToLogs: true,
		forwardConsoleLogs: ['error', 'warn'],
		sessionSampleRate: 100
	});
}

export const configureDatadogUser = ({ userId, sessionId, deviceId }: ErrorReportingUser) => {
	const user = {
		id: userId,
		...(sessionId ? { session_id: sessionId } : {}),
		...(deviceId ? { device_id: deviceId } : {})
	};

	datadogRum.setUser(user);
	datadogLogs.setUser(user);
};
